// ----------------------------------------------------------------------------
// Animations
// ----------------------------------------------------------------------------
//
// Stores all iamota animation variation for reference into individual components.
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import $ from 'jquery';


// -------------------------------------
// Load Styles
// -------------------------------------

import './animations.scss';


// -------------------------------------
// Hooks
// -------------------------------------

$(document).ready(function() {
    function scrollAnimation () {
        $.fn.visible = function(partial) {
            var $t            = $(this),
                $w            = $(window),
                viewTop       = $w.scrollTop(),
                viewBottom    = viewTop + $w.height(),
                _top          = $t.offset().top + 200,
                _bottom       = _top + $t.height(),
                compareTop    = partial === true ? _bottom : _top,
                compareBottom = partial === true ? _top : _bottom;

            return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
        };

        var animatedComponent = $('.animate-in');

        // Already visible modules
        animatedComponent.each(function(i, el) {
            var $this = $(el);

            if ($this.visible(true)) {
                $this.addClass('already-visible');
            }
        });

        $(window).scroll(function(event) {
            animatedComponent.each(function(i, el) {
                var $this = $(el);

                if ($this.visible(true)) {
                    $this.addClass('is-animated');
                }
            });
        }), {
           capture: true,
           passive: true
        };
    };

    scrollAnimation();
});
